"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Tab_1 = __importDefault(require("@/Components/common/Tab"));
var AdministratorComponent_module_css_1 = __importDefault(require("./AdministratorComponent.module.css"));
var AccountsListAdmin_1 = __importDefault(require("./AccountsListAdmin"));
var Tools_1 = __importDefault(require("./Tools"));
var DomainListView_1 = __importDefault(require("./DomainListView"));
var IntegrationServerListView_1 = __importDefault(require("./IntegrationServerListView"));
var AdministratorComponent = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(localStorage.getItem("adminActiveTab") || "Accounts List Admin"), active = _a[0], setActive = _a[1];
    (0, react_1.useEffect)(function () {
        var hash;
        switch (active) {
            case "Accounts List Admin":
                hash = "#/partner_accounts";
                break;
            case "Tools":
                hash = "#/tools";
                break;
            case "Domain":
                hash = "#/domainLock";
                break;
            case "Integration Servers":
                hash = "#/servers";
                break;
            default:
                hash = "";
        }
        window.location.hash = hash;
        localStorage.setItem("adminActiveTab", active);
    }, [active]);
    return (react_1.default.createElement("div", { className: AdministratorComponent_module_css_1.default["content-container"] },
        react_1.default.createElement("div", { className: AdministratorComponent_module_css_1.default.tabs },
            react_1.default.createElement(Tab_1.default, { onClick: function () { return setActive("Accounts List Admin"); }, text: t("All accounts"), active: active === "Accounts List Admin" }),
            react_1.default.createElement(Tab_1.default, { onClick: function () { return setActive("Tools"); }, text: t("Tools"), active: active === "Tools" }),
            react_1.default.createElement(Tab_1.default, { onClick: function () { return setActive("Domain"); }, text: t("Domain"), active: active === "Domain", "data-cy": "domainTabButton" }),
            react_1.default.createElement(Tab_1.default, { onClick: function () { return setActive("Integration Servers"); }, text: t("Integration Servers"), active: active === "Integration Servers", "data-cy": "integrationServersTabButton" })),
        active === "Accounts List Admin" && react_1.default.createElement(AccountsListAdmin_1.default, { key: "accounts-list-admin" }),
        active === "Tools" && react_1.default.createElement(Tools_1.default, { key: "tools" }),
        active === "Domain" && react_1.default.createElement(DomainListView_1.default, { key: "domain" }),
        active === "Integration Servers" && react_1.default.createElement(IntegrationServerListView_1.default, { key: "servers" })));
};
exports.default = AdministratorComponent;
